import { IntegerFilter, FilterItem } from '../../services/types/services'
import { StateIntegerFilter } from '../slices/filters/types'

export const extractIntegerFilter = (
  filters: FilterItem[],
): StateIntegerFilter | null => {
  const integerFilters = extractIntegerFilters(filters)

  const integerFiltersApplied = integerFilters.filter(
    filter => filter.value !== null,
  )

  if (integerFiltersApplied.length === 0) {
    return null
  }

  return integerFiltersApplied[0]
}

export const extractIntegerFilters = (
  filters: FilterItem[],
): StateIntegerFilter[] => {
  return filters
    .filter(
      (filter): filter is IntegerFilter =>
        filter.__typename === 'IntegerFilter',
    )
    .map(filter => ({
      name: filter.id,
      integerId: filter.integerId,
      integerKey: filter.integerKey || '',
      value: filter.selectedValue,
      min: filter.min,
      max: filter.max,
    }))
}
